// extracted by mini-css-extract-plugin
export default {"disabledIcon":"useActivityTypeOptions_disabledIcon__RJakn","textMargin":"useActivityTypeOptions_textMargin__Atqlt","disabledOption":"useActivityTypeOptions_disabledOption__yCQvf"};